import { render, staticRenderFns } from "./YoungsDoubleSlitViz.vue?vue&type=template&id=77898994&scoped=true"
import script from "./YoungsDoubleSlitViz.vue?vue&type=script&lang=js"
export * from "./YoungsDoubleSlitViz.vue?vue&type=script&lang=js"
import style0 from "./YoungsDoubleSlitViz.vue?vue&type=style&index=0&id=77898994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77898994",
  null
  
)

export default component.exports